// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-users[data-v-0a3ba2b1] {\n  height: 500px;\n  overflow-y: auto;\n}\n.con-vs-popup .vs-popup[data-v-0a3ba2b1] {\n  width: 70% !important;\n}\n.exists[data-v-0a3ba2b1] {\n  color: #671e85;\n}\n[dir] .exists[data-v-0a3ba2b1] {\n  background: #671e852b;\n  border-radius: 4px;\n  margin-top: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
